import React, { useState, useEffect } from "react";
import { WEBSERVICE } from "../../CoreDataService";
import { useSelector } from "react-redux";
import axios from "axios";

const TermsAndConditions = () => {
  const { brokerBasicInfo } = useSelector((state) => state);
  const [companyName, setCompanyName] = useState("PAYBITO");
  const [domain, setDomain] = useState();
  useEffect(() => {
    getBrokerWhitelabelDetails();
  }, [companyName]);
  const getBrokerWhitelabelDetails = async () => {
    try {
      console.log("calling broker details");
      const response = await axios.get(
        `${WEBSERVICE}home/getBrokerWiseExchangeInfo?brokerId=${brokerBasicInfo?.brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(
        "response?.data?.value[0]?.company_name",
        response?.data?.value[0]?.company_name
      );
      setCompanyName(response?.data?.value[0]?.company_name || "PAYBITO");
      setDomain(response.data?.domain);
    } catch (error) {
      console.error("Error fetching broker details:", error);
    }
  };
  console.log("companayyaya", companyName, domain);
  return (
    <div className="container px-4 py-5" id="featured-3">
      <h2 className="pb-2 border-bottom text-center">Terms and Conditions</h2>

      {/* Legal Information Section */}
      <div className="row g-4 py-3 row-cols-1 row-cols-lg-3">
        <h3 className="pb-2">Legal information</h3>
        <div className="col-md-12">
          <p>
            {companyName}{" "}
            {`(hereinafter "The Platform Technology" or ${companyName})`}{" "}
            provides access to crypto assets exchange platform technology under
            "{companyName}" (website {domain} and {companyName} Android App,{" "}
            {companyName} iPhone App).
          </p>
          <p>
            In case of any legal inquiries please contact us via legal@
            {companyName}.com.
          </p>
        </div>
      </div>
      <hr className="border-botom" />

      {/* General Disclaimer Section */}
      <div className="row g-4 py-3 row-cols-1 row-cols-lg-3">
        <h3 className="pb-2">General Disclaimer</h3>
        <div className="col-md-12">
          <p>
            Any individual (the "user"), who opens an account with {companyName}{" "}
            understands and accepts that crypto assets do not necessarily have a
            specific form of protection or regulation by any governmental body.
            The value of these crypto assets is highly volatile and speculative,
            extending the possibility of total loss.
          </p>
          <p>
            As far as The Platform Technology acts solely as an intermediary
            bringing together buyers and sellers nothing on the {companyName}{" "}
            can be ensured to contain no errors, mistakes, mis-presentations or
            failures etc. Such errors, mistakes, mis-presentations or failures
            etc. can be without limitation the result of human agency, program
            or process imperfections. THEREFORE, NEITHER {companyName} NOR,
            WHERE APPLICABLE, ANY OF THEIR RESPECTIVE DIRECTORS, OFFICERS,
            EMPLOYEES, AGENTS OR OUTSOURCED ADVISORS MAKES ANY REPRESENTATION,
            WARRANTY OR GUARANTEE WHATSOEVER WITH RESPECT TO THE INFORMATION
            AND, IN PARTICULAR, AS TO THE ACCURACY OR COMPLETENESS OF THE
            INFORMATION AND/OR PROCESS. Moreover, {companyName} is not
            responsible for any loss of money, assets, securities and other
            types of property happened because of using any information from the{" "}
            {companyName} or trading on {companyName}.
          </p>
          <p>
            No kind of trade agreement or contract is created between{" "}
            {companyName} and the users of the {companyName}. The {companyName}{" "}
            and its users act independently and do not create any partnership,
            joint venture, agency, franchise, sales representative, or
            secondment relationship between them.
          </p>
          <p>
            BY CONTINUOUS USE OF THE {companyName} YOU FULLY INDEMNIFY AND HOLD
            HARMLESS THE {companyName}, IT’S OWNERS, OFFICERS AND RESPECTIVE
            DIRECTORS, AGAINST ALL AND ANY CLAIMS, ACTIONS, DEMANDS, COSTS AND
            EXPENSES, WHICH MAY ARISE IN RELATION TO AND/OR AS A RESULT OF YOUR
            USE OF THE {companyName}.
          </p>
          <h4 className="pb-2">Crypto coins and tokens Policy</h4>
          <p>
            {companyName} accepts deposits and provides withdrawals in crypto
            assets and fiat currencies as demonstrated in the exchange platform.
          </p>
          <p>
            However, {companyName} reserves the right to reject any deposits and
            suspend withdrawals which its compliance and risk management service
            provider has decided to be the result of detecting of suspicious
            activity such as criminal activity or any other infringement of its
            compliance guidelines.
          </p>
        </div>
      </div>
      <hr className="border-botom" />

      {/* Terms of Service Section */}
      <div className="row g-4 py-3 row-cols-1 row-cols-lg-3">
        <h3 className="pb-1">TERMS OF SERVICE</h3>
        <div className="col-md-12">
          <h5>Last updated: 5 May 2018</h5>
          <p>
            These Terms of Services and any terms incorporated herein (the
            “Terms”) apply to your (“User”) use of the “Technology platform”,
            including {domain}, the technology and the platform integrated
            therein and any applications associated therewith, which are
            operated and maintained by {companyName} and its subsidiaries (“
            {companyName}”, “We”, or “Us”). We provide you the possibility to
            use Our Technology Platform (“Services”) on the following terms and
            conditions.
          </p>
        </div>
      </div>
      <hr className="border-botom" />

      {/* General Provisions Section */}
      <div className="row g-4 py-3 row-cols-1 row-cols-lg-2">
        <h3 className="pb-1">(I) GENERAL PROVISIONS</h3>
        <div className="col-md-12">
          <h6>
            User may open an account with {companyName} subject to the following
            conditions.
          </h6>
          <strong>(1) DEFINITIONS</strong>
          <p>
            1.1 &ldquo;Communications&rdquo; shall mean all and any
            communication, agreement, document, receipt, notice and disclosure,
            which may be from time to time addressed to User by {companyName}.
          </p>
          <p>
            1.2 Crypto assets&rdquo; shall mean such type of assets which can
            only and exclusively be transmitted by means of blockchain
            technology, including but not limited to digital coins and digital
            tokens and any other type of digital mediums of exchange, such as
            Bitcoin, Ethereum, Ripple, etc, to the full and absolute exempt of
            the securities of any kind.
          </p>
          <p>
            1.3 &ldquo;Deposit/Withdrawal&rdquo; of crypto assets shall mean
            remittance of crypto assets to/from {companyName} Account from/to
            external third-party service accordingly.
          </p>
          <p>
            1.4 &ldquo;Feedback&rdquo; is any feedback, suggestion, idea or
            other information or material regarding {companyName} or our
            Services that you provide, whether by email, posting through our
            Services or otherwise.
          </p>
          <p>
            1.5 "Force Majeure Event" shall be understood as any event beyond{" "}
            {companyName}'s reasonable control, including but not limited to the
            flood, extraordinary weather conditions, earthquake, or other act of
            God, fire, war, insurrection, riot, labor dispute, accident, action
            of government, suspension of bank accounts of any kind,
            extraordinary leaps of the course of crypto asset, communications,
            network or power failure, or equipment or software malfunction or
            any other cause beyond {companyName}'s reasonable control.
          </p>
          <p>
            1.6 &ldquo;{companyName} Account&rdquo; is a User account accessible
            after the registration process and via the Services where crypto
            assets may be stored and operated by {companyName} on behalf of a
            User.
          </p>
          <p>
            1.7 &ldquo;{companyName} IP&rdquo; shall mean all and any copyright
            and other intellectual property rights in all content and other
            materials contained on the Technology Platform or provided in
            connection with the Services, including, without limitation, the{" "}
            {companyName} name, trademark, {companyName} logo and all designs,
            text, graphics, pictures, information, data, software, technologies,
            know-hows, sound and video files, other files and the selection and
            arrangement thereof.
          </p>
          <p>
            1.8 "Third-Party Content" is the content provided by third parties,
            including without limitation links to web pages of such parties,
            which may be represented on the Technology Platform.
          </p>
          <p>
            1.9 "Third-party service" is any platform or network in which crypto
            assets belong to you or where you are the beneficial owner of crypto
            assets; and this platform is maintained by a third party outside of
            the Services; including, but not limited to third-party accounts.
          </p>
          <p>
            1.10 &ldquo;Trade&rdquo; shall be understood as an exchange of the
            crypto asset of one type, owned by one {companyName} Account User,
            to the crypto asset of another type, owned by the same or another{" "}
            {companyName} account User, at the terms and conditions set forth by
            such exchange parties, and which is executed solely and exclusively
            within the Technology Platform with crypto assets deposited to those
            Users&rsquo; {companyName} Accounts. In no case shall the Trade be
            deemed or construed to be a marginal trade.
          </p>
          <p>
            1.11 &ldquo;Transfer&rdquo; for the purposes herein shall mean a
            record of Deposit, Withdrawal and/or Trade transaction of crypto
            asset into, out from or at User&rsquo;s {companyName} Account, which
            is technically executed by {companyName} in accordance with
            User&rsquo;s Deposit/Withdrawal request or Trade order.
          </p>
          <strong>(2) WARRANTIES, REPRESENTATIONS AND COVENANTS</strong>
          <p>
            2.1 It is a pre-condition that our Services are only provided to
            those who are permitted to enter in legally binding relationships.
            Therefore, if there is any reason why you are not able to enter into
            legally binding relationships with Us, for whatever reason - do not
            use our Services.
          </p>
          <p>2.2 You further represent and warrant that you:</p>
          <p>
            2.2 (a) are at least 18 years old or of other legal age, according
            to your relevant jurisdiction;
          </p>
          <p>
            2.2 (b) have not previously been suspended or removed from our
            Services;
          </p>
          <p>
            2.2 (c) have full power and authority to enter into this legal
            relationship and by doing so will not violate any other legal
            relationships;
          </p>
          <p>
            2.2 (d) use our Technology Platform with your own email and for your
            own benefit and do not act on behalf and/or to the interest of any
            other person;
          </p>
          <p>
            2.2 (e) guarantee that your crypto assets, which you transfer to the
            Technology Platform are not sold, encumbered, not in contention, or
            under seizure, and that neither exist any rights of third parties to
            your crypto assets;
          </p>
          <p>
            2.2 (f) will not use our Services or will immediately cease using
            those if any applicable law in your country prohibits or will
            prohibit you at any time from doing so;
          </p>
          <p>
            2.2 (g) will not use our Services or will immediately cease using
            those if you are a resident or become a resident at any time of the
            state or region (in accordance with such state or region definition
            of residency), where the crypto assets transactions you are going to
            execute are prohibited or require special approval, permit and/or
            authorization of any kind, which {companyName} has not obtained in
            this state or region. In case of any doubts, immediately and prior
            to any use of the Services, contact us at{" "}
            <a href="javascript:void(0);">legal@{companyName}.com</a> and we
            will provide you with the information, whether We have any approval,
            permit or authorization in the state or region you are the resident
            of.
          </p>
          <p>
            2.3 When accessing or using the Technology Platform, you further
            represent, agree and warrant, that you will not violate any law,
            contract, intellectual property or other third-party right or commit
            a tort, and that you are solely responsible for your conduct while
            using our Technology Platform. Without prejudice to the generality
            of the foregoing, you represent, agree and warrant, that you will
            not:
          </p>
          <p>
            2.3 (a) Use the Technology Platform in any manner that could
            interfere with, disrupt, negatively affect or inhibit other users
            from using our Technology Platform with full functionality, or that
            could damage, disable, overburden or impair the functioning of
            Technology Platform in any manner;
          </p>
          <p>
            2.3 (b) Use the Technology Platform to pay for, support or otherwise
            engage in any illegal gambling activities; fraud; money-laundering;
            or terrorist activities; or any other illegal activities;
          </p>
          <p>
            2.3 (c) Use any robot, spider, crawler, scraper or other automated
            means or interface not provided by Us to access the Technology
            Platform or to extract data;
          </p>
          <p>
            2.3 (d) Use or attempt to use another User account without
            authorization;
          </p>
          <p>
            2.3 (e) Attempt to circumvent any content filtering techniques We
            employ, or attempt to access any service or area of our Technology
            Platform that you are not authorized to access;
          </p>
          <p>
            2.3 (f) Develop any third-party applications that interact with our
            Technology Platform without our prior written consent;
          </p>
          <p>2.3 (g) Provide false, inaccurate, or misleading information;</p>
          <p>
            2.3 (h) Encourage or induce any third party to engage in any of the
            activities prohibited under this Section.
          </p>
          <p>
            2.4 YOU INDEMNIFY AND HOLD {companyName} HARMLESS AGAINST ANY
            CLAIMS, DEMANDS AND DAMAGES, WHETHER DIRECT, INDIRECT, CONSEQUENTIAL
            OR SPECIAL, OR ANY OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT
            LIMITED TO, LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN
            AN ACTION IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO
            NEGLIGENCE) OR OTHERWISE, ORIGINATED FROM OR IN ANY WAY CONNECTED
            WITH INVALIDITY OR BREACH OF ANY OF THE WARRANTIES, REPRESENTATIONS
            AND COVENANTS OF THIS SECTION AND THE ENTIRE TERMS.
          </p>
          <strong>(3) RISK DISCLOSURE</strong>
          <p>
            3.1 Due to our internal policies, We only provide the Services to
            users with sufficient experience, knowledge and understanding of the
            work principles of our Technology Platform, and those who fully
            understand the associated risks. You acknowledge and agree that you
            shall access and use the Technology Platform at your own risk. The
            risk of loss in Trading crypto assets can be substantial. You
            should, therefore, carefully consider whether such Trading is
            appropriate for you in light of your circumstances and resources.
            You acknowledge and agree the possibility of the following:
          </p>
          <p>
            3.1 (a) You may sustain a total loss of the crypto assets in your{" "}
            {companyName} Account, and, in some cases, you may incur losses
            beyond such crypto assets.
          </p>
          <p>
            3.1 (b) Under certain market conditions, you may find it difficult
            or impossible to liquidate a position. This can occur, for example,
            when the market reaches a daily price fluctuation limit ("limit
            move") and there is insufficient liquidity in the market.
          </p>
          <p>
            3.1 (c) Placing contingent orders, such as "stop-loss" or
            "stop-limit" orders, will not necessarily limit your losses to the
            intended amounts, since market conditions may make it impossible to
            execute such orders.
          </p>
          <p>
            3.1 (d) All crypto assets positions involve risk, and a "spread"
            position may not be less risky than an outright "long" or "short"
            position.
          </p>
          <p>
            3.1 (e) The use of leverage can work against you as well as for you
            and can lead to large losses as well as gains.
          </p>
          <p>
            3.1 (f) All of the points noted above apply to all crypto assets.
            This brief statement cannot, however, disclose all the risks and
            other aspects associated with the Trade of crypto assets and shall
            not be considered as any professional advice.
          </p>
          <p>
            3.2 Risks Associated with the Internet-based Trading System. You
            acknowledge that there are risks associated with utilizing an
            Internet-based trading system including, but not limited to, the
            failure of hardware, software, and Internet connections. You
            acknowledge that {companyName} shall not be responsible for any
            communication failures, disruptions, errors, distortions or delays
            you may experience when using the Technology Platform, howsoever
            caused.
          </p>
          <p>
            3.3 Risks Associated with the Blockchain Protocol. The Technology
            Platform and its related Services are based on the Blockchain
            protocol. As such, any malfunction, unintended function, unexpected
            functioning of or attack on the Blockchain protocol may cause the
            Technology Platform to malfunction or function in an unexpected or
            unintended manner.
          </p>
          <p>
            3.4 Risks Associated with Blockchains and Crypto Assets. You
            acknowledge and accept that the {companyName} has no control over
            any cryptocurrency network and you understand all risks associated
            with utilizing any crypto assets network, including, but not limited
            to the risk of unknown vulnerabilities in or unanticipated changes
            to any network protocol. We will not be responsible for any harm
            occurring as a result of such risks.
          </p>
          <p>
            3.5 No Control Over Your Own Actions. As defined in the foregoing
            cl. 4.3 (g) and other provisions herein YOU AGREE TO INDEMNIFY AND
            HOLD {companyName} HARMLESS AGAINST ANY CLAIMS, DEMANDS AND DAMAGES,
            WHETHER DIRECT, INDIRECT, CONSEQUENTIAL OR SPECIAL, OR ANY OTHER
            DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED TO, LOSS OF USE,
            LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN AN ACTION, IN CONTRACT,
            TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR OTHERWISE,
            ORIGINATED FROM OR IN ANY WAY CONNECTED WITH YOUR USE OF OUR
            TECHNOLOGY PLATFORM, INCLUDING, BUT NOT LIMITED TO THOSE ARISING
            FROM YOUR PERSONAL ERROR AND MISBEHAVIOR SUCH AS FORGOTTEN
            PASSWORDS, INCORRECTLY CONSTRUCTED TRANSACTIONS, LOSS OF YOUR
            ACCESSES ETC.
          </p>
          <strong>(4) CRYPTO ASSETS PROTECTION</strong>
          <p>
            4.1 We strive to protect your crypto assets from unauthorized
            access, use, or spending. We use a variety of physical and technical
            measures designed to protect our systems and your crypto assets. By
            remitting your crypto assets to {companyName} Account you entrust
            and entitle Us to ultimately take decisions on the safety and
            security of your crypto assets.
          </p>
          <p>
            4.2. Requests from legal entities and individuals to {companyName}{" "}
            can be sent via email to 
            <a href={`mailto:support@${companyName}.com`}>
              support@{companyName}.com
            </a>
            .
          </p>
          <p>4.3. Our address for correspondence is mentioned above.</p>
          <p>
            4.4. To legal entities and individuals we can disclose only
            information and data concerning the activity of the petitioner as
            our user.
          </p>
          <p>
            4.5. We reserve the right to keep the confidential information about
            third parties undisclosed to the petitioners.
          </p>

          <strong>5.Exemption of Liabilities</strong>

          <p>
            5.1. The information and data supplied in response to requests is
            endeavored to be collected and provided to the fullest and most
            accurate possible extent. However, nothing in such information and
            data can be ensured to contain no errors, mistakes,
            mis-presentations or failures etc. Such errors, mistakes,
            mis-presentations or failures etc. can be the result of human
            agency, program or process imperfections, such as i.e.
            crypto-validation deficiency. THEREFORE, NEITHER {companyName} NOR
            WHERE APPLICABLE ANY OF OUR RESPECTIVE DIRECTORS, OFFICERS,
            EMPLOYEES, AGENTS OR OUTSOURCED ADVISORS MAKES ANY REPRESENTATION,
            WARRANTY OR GUARANTEE WHATSOEVER WITH RESPECT TO THE INFORMATION AND
            DATA AND, IN PARTICULAR, AS TO THE ACCURACY OR COMPLETENESS OF THE
            INFORMATION AND DATA.
          </p>
          <p>
            5.2. Nothing in this section shall be deemed or construed as
            non-willingness to provide the requested information and data.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
